import { render, staticRenderFns } from "./legalStartScale.vue?vue&type=template&id=649c99e2&scoped=true&"
import script from "./legalStartScale.vue?vue&type=script&lang=ts&"
export * from "./legalStartScale.vue?vue&type=script&lang=ts&"
import style0 from "./legalStartScale.vue?vue&type=style&index=0&id=649c99e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c99e2",
  null
  
)

export default component.exports